import React, { useState, useEffect } from "react";
import { getLeaderBoard } from '../../../api/api.js'
import AppBar from '../../../components/app_bar.js'
import BottomNavBar from "../../../components/bottom_nav_bar.js";
import Background from "../../../components/background.js";
import '../style/friends_page.css'
import { useNotification } from "../../../components/NotificationProvider";
import t from "../../../translate";
function FriendsPage() {
  const { addNotification } = useNotification();

  const [leaderboardData, setLeaderboardData] = useState([]);

  const copyReferral = () => {
    const referralText = document.querySelector('.link')?.textContent; // Отримуємо текст посилання
    if (!referralText) return;

    navigator.clipboard.writeText(referralText)
      .then(() => {
        addNotification('success', 'Ссылка скопирована в буфер обмена');
      })
      .catch(err => console.error("Помилка копіювання:", err));
  };

  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const data = await getLeaderBoard().catch((err) => addNotification('error', t(localStorage.getItem('lang'), 'errorMessage')))
        setLeaderboardData(data || []);
      } catch (error) {
        console.error("Помилка при завантаженні даних:", error);
      }
    };

    fetchLeaderboardData();
  }, [addNotification]);


  return <>
    <AppBar />
    <BottomNavBar />
    <Background />
    <div className="friends-page default-page-setting">
      <div className="top-content top-margin">
        <h5 className="friends-page-title">{t(localStorage.getItem('lang'), 'earnWithFriends')}</h5>
        <h5 className="friends-page-main-text">{t(localStorage.getItem('lang'), 'inviteFriends')}</h5>
      </div>
      <div className="link-row" id="referralInput">
        <div className="link">{`${process.env.REACT_APP_BOT_LINK}?start=${localStorage.getItem('referral')}`}</div>
        <div onClick={copyReferral} style={{ cursor: "pointer" }}>
          <img src="/assets/icons/ic_copy.svg" className="navbar-icon" alt="ic_copy" />
        </div>
      </div>
      <div>
        <h5 className="friends-page-main-text">{t(localStorage.getItem('lang'), 'yourFriends')}: {localStorage.getItem('referrals') || 0}</h5>
        <h5 className="friends-page-main-text">{t(localStorage.getItem('lang'), 'yourActiveFriends')}:{(+localStorage.getItem('activeReferrals') || 0) + (+localStorage.getItem('virtualFriend') || 0)}</h5>
        <p className="friends-page-main-text-new ">{t(localStorage.getItem('lang'), 'activeFriendDescription')}</p>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>{t(localStorage.getItem('lang'), 'tableHeaderName')}</th>
                <th>{t(localStorage.getItem('lang'), 'tableHeaderPoints')}</th>
                <th>{t(localStorage.getItem('lang'), 'tableHeaderActiveFriends')}</th>
              </tr>
            </thead>
            <tbody>
              {leaderboardData.length > 0 ? (
                leaderboardData.map((user, index) => (
                  <tr key={index}>
                    <td>{user.first_name?.length > 15 ? user?.first_name?.slice(0, 15) : user?.first_name || user.username?.length > 15 ? user?.username?.slice(0, 15) : user?.username || 'No name'}</td>
                    <td>{(user.totalSum).toFixed(3)}</td>
                    <td>{(user.activeReferrals)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3">{t(localStorage.getItem('lang'), 'tableHeaderLoad')}</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </div>

  </>;
}

export default FriendsPage;